jQuery(($) => {
  if ( $('.o-notification-bar')[0] ) {
    var data_id = $('.o-notification-bar').attr('data-id');

    if (localStorage.getItem('popState_' + data_id) != 'shown') {
        $('.o-notification-bar').show();
        $('.o-header').addClass('o-header--notification-bar');
    }

    $('.o-notification-bar__close-button').click(function () {
        localStorage.setItem('popState_' + data_id, 'shown');

        $(this).remove();

        $('.o-notification-bar').slideUp();

        $('.o-header').removeClass('o-header--notification-bar');
    });
  }
});